import { isBrandInNAM } from "@faire/help-center-self-serve/utils/isBrandInNAM";
import { Button } from "@faire/web--source/slate/Button";
import { Column } from "@faire/web--source/slate/Layout";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import brandPortalAccountRoute from "@faire/web-api--source/routes/brand-portal/account";
import React from "react";
import { Bold } from "../common/Bold";
import { RowWithBullet } from "../common/RowWithBullet";
export var UpdatePayoutsIA = function UpdatePayoutsIA(_ref) {
  var brand = _ref.brand;
  if (isBrandInNAM(brand)) {
    return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "gbEM9B",
      defaultMessage: [{
        "type": 0,
        "value": "Je kunt zelf kiezen wanneer je betaald wilt worden nadat je bestellingen zijn verzonden. Uitbetalingen worden uitgevoerd op basis van de gekozen uitbetalingsoptie, maar het kan 3 tot 5 werkdagen duren voordat ze op je rekening staan, afhankelijk van de verwerkingstijd van je bank. Je betalingsverwerkingskosten zijn gebaseerd op de door jou gemaakte keuze."
      }]
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg
    /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */, {
      id: "CYGSaU",
      /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Uitbetaling de volgende dag"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": 3,5% + $ 0,30"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg
    /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */, {
      id: "zaIu+A",
      /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Uitbetaling na 30 dagen"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": 2,4% + $ 0,30"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    }))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg
    /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */, {
      id: "bZnAZH",
      /* eslint-disable-next-line @faire/no-dollar-symbol-in-strings */
      defaultMessage: [{
        "children": [{
          "type": 0,
          "value": "Uitbetaling na 60 dagen"
        }],
        "type": 8,
        "value": "BoldFormatting"
      }, {
        "type": 0,
        "value": ": 1,9% + $ 0,30"
      }],
      values: {
        BoldFormatting: function BoldFormatting(chunks) {
          return _BoldFormatting(chunks);
        }
      }
    })))), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "q1sTS9",
      defaultMessage: [{
        "type": 0,
        "value": "Om je uitbetalingsoptie en bijbehorende betalingsverwerkingskosten te wijzigen, ga je naar "
      }, {
        "children": [{
          "type": 0,
          "value": "Accountinstellingen"
        }],
        "type": 8,
        "value": "AccountSettingLinkFormatting"
      }, {
        "type": 0,
        "value": " en selecteer je het tabblad "
      }, {
        "children": [{
          "type": 0,
          "value": "Uitbetaling"
        }],
        "type": 8,
        "value": "PayoutLinkFormatting"
      }, {
        "type": 0,
        "value": "."
      }],
      values: {
        AccountSettingLinkFormatting: function AccountSettingLinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "my-account");
        },
        PayoutLinkFormatting: function PayoutLinkFormatting(chunks) {
          return PayoutsLinkFormatting(chunks, "payment");
        }
      }
    })), /*#__PURE__*/React.createElement(Spacer, {
      height: "1x"
    }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
      id: "oGyzWH",
      defaultMessage: [{
        "type": 0,
        "value": "Wijzigingen zijn van toepassing op alle toekomstige bestellingen die worden geplaatst nadat de uitbetalingsinstelling is bijgewerkt. Neem contact met ons op om je uitbetalingsoptie op bestaande bestellingen te wijzigen."
      }]
    })));
  }
  return /*#__PURE__*/React.createElement(Column, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "iMNCJo",
    defaultMessage: [{
      "type": 0,
      "value": "Je kunt zelf kiezen wanneer je betaald wilt worden nadat je bestellingen zijn verzonden. Uitbetalingen worden uitgevoerd op basis van de gekozen uitbetalingsoptie, maar het kan 3 tot 5 werkdagen duren voordat ze op je rekening staan, afhankelijk van de verwerkingstijd van je bank. Je betalingsverwerkingskosten zijn gebaseerd op de door jou gemaakte keuze."
    }]
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement("ul", null, /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "3kOCho",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "ACH Next Day"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": uitbetalingskosten van 3% worden toegepast op zowel de bestelling als de verzendkosten"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  }))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(RowWithBullet, null, /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "ljpEqK",
    defaultMessage: [{
      "children": [{
        "type": 0,
        "value": "ACH 30-day"
      }],
      "type": 8,
      "value": "BoldFormatting"
    }, {
      "type": 0,
      "value": ": geen uitbetalingskosten"
    }],
    values: {
      BoldFormatting: function BoldFormatting(chunks) {
        return _BoldFormatting(chunks);
      }
    }
  })))), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "S45UJf",
    defaultMessage: [{
      "type": 0,
      "value": "Om je uitbetalingsoptie en bijbehorende betalingsverwerkingskosten te wijzigen, ga je naar "
    }, {
      "children": [{
        "type": 0,
        "value": "Accountinstellingen"
      }],
      "type": 8,
      "value": "AccountSettingLinkFormatting"
    }, {
      "type": 0,
      "value": " en selecteer je het tabblad "
    }, {
      "children": [{
        "type": 0,
        "value": "Uitbetaling"
      }],
      "type": 8,
      "value": "PayoutLinkFormatting"
    }, {
      "type": 0,
      "value": "."
    }],
    values: {
      AccountSettingLinkFormatting: function AccountSettingLinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "my-account");
      },
      PayoutLinkFormatting: function PayoutLinkFormatting(chunks) {
        return PayoutsLinkFormatting(chunks, "payment");
      }
    }
  })), /*#__PURE__*/React.createElement(Spacer, {
    height: "1x"
  }), /*#__PURE__*/React.createElement(Typography, null, /*#__PURE__*/React.createElement(StrictLocalMsg, {
    id: "JR23KI",
    defaultMessage: [{
      "type": 0,
      "value": "Wijzigingen zijn van toepassing op alle toekomstige bestellingen die worden geplaatst nadat de uitbetalingsinstelling is bijgewerkt. Neem contact met ons op om je uitbetalingsoptie op bestaande bestellingen te wijzigen."
    }]
  })));
};
var PayoutsLinkFormatting = function PayoutsLinkFormatting(chunks, tab) {
  return /*#__PURE__*/React.createElement(Button, {
    variant: "tertiary",
    linkTo: brandPortalAccountRoute({
      tab: tab
    }),
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Bold, null, chunks));
};
var _BoldFormatting = function _BoldFormatting(chunks) {
  return /*#__PURE__*/React.createElement(Bold, null, chunks);
};